import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index/Index'
import axios from 'axios'
import store from '@/store/index.js'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/page/Login/Login.vue'),
      meta: {
        title: '登录',
      }
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '首页',
        requireAuth: true
      }
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component:  () => import('@/page/Equipment/Equipment.vue'),
      meta: {
        title: '产品管理',
        requireAuth: true
      }
    },
    {
      path: '/order',
      name: 'Order',
      component:  () => import('@/page/Order/Order.vue'),
      meta: {
        title: '订单管理',
        requireAuth: true
      }
    },
    {
      path: '/data-statistics',
      name: 'DataStatistics',
      component:  () => import('@/page/Order/DataStatistics.vue'),
      meta: {
        title: '数据统计',
        requireAuth: true
      }
    },
    {
      path: '/alipay/unfreeze',
      name: 'UnFreezeOrder',
      component:  () => import('@/page/Order/UnFreezeOrder.vue'),
      meta: {
        title: '预授权订单',
        requireAuth: true
      }
    },
    {
      path: '/wx/unfreeze',
      name: 'WxUnFreezeOrder',
      component:  () => import('@/page/Order/WxUnFreezeOrder.vue'),
      meta: {
        title: '支付分订单',
        requireAuth: true
      }
    },
    {
      path: '/order/customer',
      name: 'CustomerOrder',
      component:  () => import('@/page/Order/CustomerOrder.vue'),
      meta: {
        title: '客服订单',
        requireAuth: true
      }
    },
    {
      path: '/deposit',
      name: 'Deposit',
      component:  () => import('@/page/Equipment/Deposit.vue'),
      meta: {
        title: '押金修改',
        requireAuth: true
      }
    },
    {
      path: '/admin-user',
      name: 'AdminUser',
      component:  () => import('@/page/Permission/AdminUser.vue'),
      meta: {
        title: '后台用户管理',
        requireAuth: true
      }
    },
    {
      path: '/admin-role',
      name: 'AdminRole',
      component:  () => import('@/page/Permission/AdminRole.vue'),
      meta: {
        title: '后台角色设置',
        requireAuth: true
      }
    },
    {
      path: '/admin-auth',
      name: 'AdminAuth',
      component:  () => import('@/page/Permission/AdminAuth.vue'),
      meta: {
        title: '权限设置',
        requireAuth: true
      }
    },
    {
      path: '/modify-password',
      name: 'ModifyPassword',
      component:  () => import('@/page/Permission/Password.vue'),
      meta: {
        title: '密码修改',
        requireAuth: true
      }
    },
    {
      path: '/userinfo',
      name: 'UserInfo',
      component:  () => import('@/page/User/Index.vue'),
      meta: {
        title: '用户查询',
        requireAuth: true
      }
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component:  () => import('@/page/Merchant/Index.vue'),
      meta: {
        title: '商户查询',
        requireAuth: true
      }
    },
    {
      path: '/product',
      name: 'Product',
      component:  () => import('@/page/product/product.vue'),
      meta: {
        title: '产品查询',
        requireAuth: true
      }
    },
    {
      path: '/user/card',
      name: 'UserCard',
      component:  () => import('@/page/user/Card.vue'),
      meta: {
        title: '会员卡管理',
        requireAuth: true
      }
    },
    {
      path: '/user/card-record',
      name: 'UserCardRecord',
      component:  () => import('@/page/user/CardRecord.vue'),
      meta: {
        title: '购卡查询',
        requireAuth: true
      }
    },
    {
      path: '/equipment/share',
      name: 'EquipmentShare',
      component:  () => import('@/page/equipment/Share.vue'),
      meta: {
        title: '设备弹出',
        requireAuth: true
      }
    },
    {
      path: '/equipment/authorize',
      name: 'EquipmentShare',
      component:  () => import('@/page/equipment/Authorize.vue'),
      meta: {
        title: '设备弹出',
        requireAuth: true
      }
    }
  ]
})



router.beforeEach(function (to, from, next) {
  
  if (to.path === '/login') {
    next();
  } else {
    let token = store.state.userModule.token;
    if (token === 'null' || token === '') {
      next('/login');
    } else {
      document.title = to.meta.title + `-爱康贝`;
      next();
    }
  }

});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js